import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL from the old site with live backlinks (Ahrefs: 3 referring
// domains). 301 to the coach directory so the link equity flows there.
export const Route = createFileRoute("/_public/our-coaches")({
  beforeLoad: () => {
    throw redirect({
      to: "/coaches",
      statusCode: 301,
    });
  },
  component: () => null,
  staticData: { title: "Our Coaches" },
});
